import { api } from "../App";

import {
    GET_STRUCTURAL_DIVISIONS,
} from "./types";


export const getStructuralDivisions = () => async (dispatch, getState) => {
    try {
        const { data } = await api.get('/org_struct');
        dispatch({ type: GET_STRUCTURAL_DIVISIONS, payload: data });
    } catch (ERR) {
    } finally {
    }
}

export const createStructuralDivisions = (data) => async (dispatch, getState) => {
    let success
    try {
        await api.post('/org_struct', data);
        await dispatch(getStructuralDivisions())
        success = true
    } catch (ERR) {
    } finally {
        return success
    }
}

export const updateStructuralDivisions = (id, data) => async (dispatch, getState) => {
    let success
    try {
        await api.put(`/org_struct/${id}`, data);
        await dispatch(getStructuralDivisions())
        success = true
    } catch (ERR) {
    } finally {
        return success
    }
}

export const deleteStructuralDivisions = (id) => async (dispatch, getState) => {
    try {
        await api.delete(`/org_struct/${id}`);
        await dispatch(getStructuralDivisions())
    } catch (ERR) {
    } finally {
    }
}